import React, { useState, useCallback } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import GlobalHeader from './GlobalHeader';
import './AppShell.css';

const AppShell = ({
  language = 'he',
  onLanguageToggle,
  onProfileClick,
  onPasswordClick,
  onUsersClick,
  onAuditClick,
}) => {
  const [collapsed, setCollapsed] = useState(() => {
    return localStorage.getItem('sidebarCollapsed') === 'true';
  });
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleToggleCollapse = useCallback(() => {
    setCollapsed(prev => {
      const next = !prev;
      localStorage.setItem('sidebarCollapsed', String(next));
      return next;
    });
  }, []);

  const handleToggleMobile = useCallback(() => {
    setMobileOpen(prev => !prev);
  }, []);

  const handleCloseMobile = useCallback(() => {
    setMobileOpen(false);
  }, []);

  // Keying the outlet wrapper by path re-runs the rise-in animation on
  // every navigation, so moving between screens feels alive.
  const location = useLocation();

  return (
    <div className={`app-shell ${collapsed ? 'app-shell--collapsed' : ''}`}>
      <Sidebar
        language={language}
        collapsed={collapsed}
        onToggleCollapse={handleToggleCollapse}
        mobileOpen={mobileOpen}
        onCloseMobile={handleCloseMobile}
      />
      <GlobalHeader
        language={language}
        onLanguageToggle={onLanguageToggle}
        onToggleSidebar={handleToggleMobile}
        onProfileClick={onProfileClick}
        onPasswordClick={onPasswordClick}
        onUsersClick={onUsersClick}
        onAuditClick={onAuditClick}
      />
      <main className="app-shell-content">
        <div key={location.pathname} className="route-transition">
          <Outlet />
        </div>
      </main>
      <footer
        className="app-shell-footer"
        dir={language === 'he' ? 'rtl' : 'ltr'}
        style={{
          textAlign: 'center',
          padding: '8px 12px',
          fontSize: '11px',
          color: '#9ca3af',
          borderTop: '1px solid #e5e7eb',
          background: '#fafafa',
        }}
      >
        TaisaCore v1.0 | tayzacore.com · © 2026 TaisaCore Ltd.
      </footer>
    </div>
  );
};

export default AppShell;
